import { PermissionKey } from '@client/api';
import { useSpacePermissions } from '../../hooks/useSpacePermissions/useSpacePermissions';
import { Button } from '@client/toolkit';

export function SpacePermissionBasedActionButton({
  spaceId,
  onClick,
  permissions,
  title,
  disabled,
}: {
  spaceId: string;
  onClick: () => void;
  permissions: PermissionKey[];
  title: string;
  disabled: boolean;
}) {
  const { hasAnyPermission } = useSpacePermissions({ id: spaceId });
  if (!hasAnyPermission(permissions)) return null;
  return (
    <Button color="primary" disabledVariant="dark" size="sm" disabled={disabled} onClick={onClick}>
      {title}
    </Button>
  );
}
